import Goods from "pages/Goods";

const GoodsStock = () => {
  return <>
    <Goods isStock={1} />
  </>
}

export default GoodsStock;